<template>
  <div class="Project vx-row ">
    <div class="vx-col md:w-3/12 w-full" >
      <div class="vx-card p-4" style="min-height: 600pt">
        <!--        dự án yêu thích-->
        <div class="">
          <div class="vx-col">
            <div class="vx-col">
              <label
                style="font-size: 15px;letter-spacing: 0.2pt;color: rgb(37 39 51);font-weight: bold">{{
                  $t('projectAndTopic.favourite')
                }}</label>
            </div>
            <div class="vx-col">
                <span v-if="optionPriority.length == 0" style="color: rgb(185 185 195);font-size: 15px">{{$t('projectAndTopic.noteFavourite')}}</span>
            </div>
          </div>
          <div class="vx-row ml-8 mt-4" v-for="(group, indexGroup) in optionPriority" :key="indexGroup"
               @update-priority="updatePriority">
            <feather-icon v-if="group.color"
                          icon="StarIcon"
                          class="mr-2"
                          style="width: 16px;height: 16px"
                          :style='{color : group.color}'
            ></feather-icon>
            <feather-icon v-else
                          icon="StarIcon"
                          class="mr-2"
                          style="width:16px;height: 16px;color: rgba(var(--vs-primary), 1)"
            ></feather-icon>
              <span class="ml-2" style="color: rgb(185 185 195);font-size: 15px"> {{ group.label }}</span>
          </div>
          <div class="vx-col mt-8">
            <vs-button icon-pack="feather"
                       icon="icon-plus"
                       color="dark"
                       type="flat"
                       style="color: rgb(185 185 195);font-size: 15px; z-index:1"
                       @click="createNewProject"
            >{{ $t('projectAndTopic.createNewProject') }}
            </vs-button>

          </div>
        </div>
        <div class="">
          <!--          button tạo mới-->
          <div class="vx-col">
<!--            <vs-button icon-pack="feather"-->
<!--                       icon="icon-plus"-->
<!--                       color="dark"-->
<!--                       type="flat"-->
<!--                       style="color: rgb(185 185 195);font-size: 15px"-->
<!--                       @click="createNewTopic"-->
<!--            >{{ $t('projectAndTopic.createNewTopic') }}-->
<!--            </vs-button>-->
            <div class="vx-col">
              <div class="vx-row p-4 pb-0">
                <vs-button icon-pack="feather"
                           icon="icon-command"
                           color="primary"
                           type="flat"
                           class="back w-full"
                           style="color: rgb(110 107 123);font-size: 18px;font-weight: bold;height:36px;"
                ><span>{{ $t('projectAndTopic.all') }}</span>
                  <span style="width: 18px;font-size:12px;vertical-align: bottom"
                        class="badge ml-4 badge-pill bg-white text-primary p-1">{{ optionGroupTopics.length + 1 }}</span>
                </vs-button>
              </div>
              <div class="vx-col ml-2">
                <vs-collapse accordion class="w-full">
                  <vs-collapse-item icon-arrow="arrow_drop_down"  v-for="(item, index) in optionGroupTopics" v-bind:key="index" >
                    <div slot="header">
                      <div class="vx-row" style="margin-left: 5px;">
                        <div v-if="item.color" class="color-group mt-0 p-0 text-center text-white"
                             :style="{background:item.color}">{{
                            responseData.filter(el => el.topicGroupId == item.value).length
                          }}
                        </div>
                        <div v-else class="color-group mt-0 p-0 text-center text-white"
                             style="background-color:rgba(var(--vs-primary), 1)">{{
                            responseData.filter(el => el.topicGroupId == item.value).length
                          }}
                        </div>
                        <span class="ml-2 mt-1 font-bold" style="font-size: 14px;color:  rgb(94 88 115)">{{ item.label }}</span>
                      </div>
                    </div>
                    <div class="topic cursor-auto "  >
                      <div class="vx-row cursor-auto" style="color: rgb(185 185 195)"
                           v-for="(item, index) in responseData.filter(el => el.topicGroupId == item.value)"
                           :key="index">
                        <div class="vx-row ml-3" @click="editTopic(item, index)">
                           <feather-icon
                          icon="ListIcon"
                          class="ml-2"
                          style="color: rgb(110 107 123);width: 1rem"
                           >
                           </feather-icon>
                           <span class="p-3 mt-1 cursor-pointer" style="font-size: 14px">{{ item.topicName }}</span>
                        </div>
                      </div>
                    </div>
                  </vs-collapse-item>
                  <vs-collapse-item icon-arrow="arrow_drop_down">
                    <div slot="header">
                      <div class="vx-row" style="margin-left: 5px;">
                        <div class="count-other text-white text-center">{{ countOther || 0 }}</div>
                        <span class="ml-1 mt-1 ml-2 font-bold"
                              style="font-size: 15px;color:  rgb(94 88 115)">{{
                            $t('projectAndTopic.otherTopics')
                          }}</span>
                      </div>
                    </div>
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0"
                                         :settings="settings" style="max-height: 18rem">
                      <div class="topic cursor-pointer text-overflow">
                        <div class="vx-row " style="color: rgb(185 185 195)"
                             v-for="(item, index) in responseData.filter(item => item.isOther)"
                             :key="index">
                          <div class="vx-row ml-3" @click="editTopic(item, index)" >
                              <feather-icon
                              icon="ListIcon"
                              class="ml-2"
                              style="color: rgb(110 107 123);width: 1rem"
                              >
                              </feather-icon>
                              <span class="p-3 mt-1" style="font-size: 14px">{{ item.topicName }}</span>
                          </div>
                        </div>
                      </div>
                    </VuePerfectScrollbar>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col md:w-9/12 w-full down-arrow" style="min-height: 600pt">
      <!--      Menu breadcrumb-->
      <!--      Collapse các dự án-->
      <div class="projects mt-2"   >
        <vs-collapse accordion :type="type"  >
          <vs-collapse-item icon-arrow="arrow_drop_down" v-for="item in optionGroupTopics" >
            <!--            header dự án-->
            <div slot="header" style="height: 20px;margin-top: -5px;">
              <div class="vx-row" style="margin-left: 8px;">
                <div v-if="item.color" class="color-group" :style="{background:item.color}"></div>
                <div v-else class="color-group text-center text-dark"
                     style="background-color: rgba(var(--vs-primary), 1)"></div>
                <span class="ml-2 mt-1 font-bold" style="font-size: 14px;color:  rgb(94 88 115)">{{ item.label }}</span>
                <span class=" mt-1 ml-6 mr-6"
                      style="font-size: 14px;color:  rgb(185 185 195)">{{
                    responseData.filter(el => el.topicGroupId == item.value).length
                  }} {{ $t('projectAndTopic.topicC') }}</span>
                <div class="buttonAdd" style="position: absolute; right:40px">
                  <vs-button icon-pack="feather"
                             icon="icon-plus"
                             color="primary"
                             type="flat"
                             style="color: rgb( 47 128 237);font-size: 12px;margin-top: -4px; z-index:1"
                             @click="createTopic(item)"
                  >{{ $t('projectAndTopic.createNewTopicC') }}
                  </vs-button>
                </div>
                <!--                dropdown dự án-->
                <div class="dropdown" style="position: absolute; right:10px">
                  <vs-dropdown class="cursor-pointer" style="margin-top: 2px;">
                    <feather-icon
                      icon="MoreHorizontalIcon"
                      class=""
                      style="color: rgb(110 107 123);width: 1.7rem"
                    >
                    </feather-icon>
                    <vs-dropdown-menu>
                      <ul style="min-width: 228pt">
                        <li class="border-bottom flex py-2 px-4 cursor-pointer cursor-auto">
                          <div class=" py-2 px-4">
                            <div class="vx-row">
                              <span>{{
                                  $t('projectAndTopic.status')
                                }} : {{ $t('projectAndTopic.isActive') }}</span>

                            </div>
                          </div>
                        </li>
                        <li class="border-bottom py-2 px-4 cursor-pointer cursor-auto ">
                          <div class="vx-col">
                            <span
                              style="color: rgb( 185 185 195)">{{ $t('projectAndTopic.info') }}</span>
                            <div class="info-topic">
                              <div>
                                <span>{{ $t('projectAndTopic.description') }} : {{ item.description }}</span>
                              </div>
                              <div>
                                <span>{{ item.userId == item.currentUserId ? $t('projectAndTopic.creator') : $t('projectAndTopic.sharedBy')  }} : {{item.createdUser || ""}}</span>
                              </div>
                              <div>
                                <span>{{ $t('projectAndTopic.createDate') }} : {{
                                    item.startDateString
                                  }} </span>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="viewStatistical(item)">
                          <feather-icon
                            icon="BarChart2Icon"
                            style="vertical-align:middle;width:1rem"
                            @click="viewStatistical(item)"
                          >
                          </feather-icon>
                          <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.viewStatistical') }}</span>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                            @click="updateProject(item)">
                          <feather-icon
                            icon="Edit3Icon"
                            style="vertical-align:middle;width:1rem"
                          >
                          </feather-icon>
                          <span class="font-action ml-2 mt-1"
                                @click="updateProject(item)">{{ $t('projectAndTopic.editProject') }}</span>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                            @click="tickFavouriteGroupTopic(item)">
                          <div v-if="!item.favourite">
                            <feather-icon
                              icon="StarIcon"
                              style="vertical-align:middle;width:1rem"
                              @click="tickFavouriteGroupTopic(item)"
                            >
                            </feather-icon>
                            <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.projectFavourite') }}</span>

                          </div>
                          <div v-else>
                            <feather-icon
                              icon="StarIcon"
                              style="vertical-align:middle;width:1rem;color:#ffb100"
                              @click="tickFavouriteGroupTopic(item)"
                            ></feather-icon>
                            <span
                              class="font-action ml-2 mt-1">{{ $t('projectAndTopic.removeFavoriteGroupTopic') }}</span>
                          </div>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                            @click="confirmRemoveTopicGroup(item)">
                          <feather-icon
                            icon="Trash2Icon"
                            style="vertical-align:middle;width:1rem"
                            @click="confirmRemoveTopicGroup(item)"
                          >
                          </feather-icon>
                          <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.deleteProject') }}</span>
                        </li>
                      </ul>
                    </vs-dropdown-menu>

                  </vs-dropdown>
                </div>
              </div>
            </div>
            <!--            Các chủ đề-->
            <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0"
                                 :settings="settings" style="min-height: 12rem;max-height: 13rem" >
              <div class="topic" style="margin-top: -10px;">
                <div class=" vx-row" style="color: rgb(185 185 195)"
                     v-for="(itemTopic, index) in responseData.filter(el => el.topicGroupId == item.value)"
                     :key="index">
                  <vs-collapse>
                    <vs-collapse-item not-arrow :type="type" >
                      <div slot="header" class="vx-row ml-6" style="height: 10px;margin-top: -20px;">
                        <div class="button" v-if="item.color">
                          <div class="" v-if="itemTopic.buttonChecked">
                              <vs-button  icon-pack="feather"
                                     icon="icon-chevron-down"
                                     :color="item.color"
                                     type="flat"
                                     @click="checkedChevron(itemTopic)"
                          >
                              </vs-button>
                          </div>
                          <div class="" v-else>
                              <vs-button  icon-pack="feather"
                                     icon="icon-chevron-up"
                                     :color="item.color"
                                     type="flat"
                                     @click="checkedChevron(itemTopic)"
                          >
                              </vs-button>
                          </div>
                        </div>
                        <div class="button" v-else>
                          <div class="" v-if="itemTopic.buttonChecked">
                              <vs-button icon-pack="feather"
                                     icon="icon-chevron-down"
                                     color="primary"
                                     type="flat"
                                     @click="checkedChevron(itemTopic)"
                          >
                              </vs-button>
                          </div>
                          <div class="" v-else>
                              <vs-button  icon-pack="feather"
                                     icon="icon-chevron-up"
                                     color="primary"
                                     type="flat"
                                     @click="checkedChevron(itemTopic)"

                          >
                              </vs-button>
                          </div>
                        </div>
                        <div class="topic-chip">
                          <vs-chip v-if="item.color" class="ag-grid-cell-chip m-2"
                                   :color="itemTopic.color || item.color">
                            <span class="" style="font-size: 13px">{{ itemTopic.topicName }}</span>
                          </vs-chip>
                          <vs-chip v-else class="ag-grid-cell-chip m-2" color="primary">
                            <span class="" style="font-size: 13px">{{ itemTopic.topicName }}</span>
                          </vs-chip>
                        </div>
                        <div class="mt-2" v-if="itemTopic.statusData" @click="crawlData(itemTopic)">
                          <feather-icon v-if="item.color"
                                        icon="PauseIcon"
                                        class="float-left ml-4"
                                        style="width: 1.5rem"
                                        :style="{color : item.color}"
                          >
                          </feather-icon>
                          <feather-icon v-else
                                        icon="PauseIcon"
                                        class="float-left ml-4"
                                        style="width: 1.5rem;color: rgb(var(--vs-primary),1)"

                          >
                          </feather-icon>
                        </div>
                        <div class="mt-2" v-else @click="crawlData(itemTopic)">
                          <feather-icon v-if="item.color"
                                        icon="PlayCircleIcon"
                                        class="float-left ml-4"
                                        style="width: 1.5rem"
                                        :style="{color : item.color}"
                          >
                          </feather-icon>
                          <feather-icon v-else
                                        icon="PlayCircleIcon"
                                        class="float-left ml-4"
                                        style="width: 1.5rem;color: rgb(var(--vs-primary),1)"
                          >
                          </feather-icon>
                        </div>
                        <span class=" mt-2 ml-6 mr-6"
                              style="font-size: 13px;color:  rgb(185 185 195)">{{
                            itemTopic.keywords.length
                          }}  {{ $t('projectAndTopic.keyword') }}</span>
                        <div class="mt-2">
                          <feather-icon v-if="item.color"
                                        icon="PlusCircleIcon"
                                        class="float-left ml-4   cursor-pointer"
                                        style="width: 1.6rem"
                                        :style="{color : item.color}"
                                        @click="createNewKeyword(itemTopic)"
                          >
                          </feather-icon>
                          <feather-icon v-else
                                        icon="PlusCircleIcon"
                                        class="float-left ml-4   cursor-pointer"
                                        style="width: 1.6rem;color: rgb(var(--vs-primary),1)"
                                        @click="createNewKeyword(itemTopic)"
                          >
                          </feather-icon>
                        </div>
                        <div class="drop-keyword mt-1 ml-6">
                          <!--                        vx-card n chủ đề-->
                          <vs-dropdown class="cursor-pointer mt-1">
                            <feather-icon
                              icon="MoreVerticalIcon"
                              class=""
                              style="color: rgb(110 107 123);width: 1.7rem"
                            >
                            </feather-icon>
                            <vs-dropdown-menu>
                              <ul style="min-width: 228pt">
                                <li class="border-bottom flex py-2 px-4 cursor-pointer">
                                  <div class=" py-2 px-4">
                                    <div class="vx-row">
                                      <span v-if="itemTopic.statusData"
                                            style="font-size: 10pt">{{
                                          $t('projectAndTopic.status')
                                        }}: {{ $t('projectAndTopic.isActive') }}</span>
                                      <span v-else
                                            style="font-size: 10pt">{{
                                          $t('projectAndTopic.status')
                                        }}: {{ $t('projectAndTopic.pause') }}</span>
                                    </div>
                                  </div>
                                </li>
                                <li class="border-bottom py-2 px-4 cursor-pointer ">
                                  <div class="vx-col">
                                    <span
                                      style="color: rgb( 185 185 195)">{{
                                        $t('projectAndTopic.info')
                                      }}</span>
                                    <div class="info-topic"
                                    >
                                      <div>
                                        <div v-if="itemTopic.currentUserName != itemTopic.createdBy">
                                          <span> {{
                                              $t('projectAndTopic.sharedBy')
                                            }} : </span>
                                          <span style="font-size: 10pt">{{ itemTopic.createdBy  }} </span>
                                        </div>
                                        <div v-else>
                                        <span class="color-col">{{ $t('projectAndTopic.creator') }} : {{
                                            itemTopic.createdBy || itemTopic.modifiedBy
                                          }}</span>
                                        </div>
                                      </div>
                                      <div>
                                        <span>{{ $t('projectAndTopic.createDate') }} : {{
                                            itemTopic.createdDateString
                                          }}  </span>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="viewStaticTopic(itemTopic)">
                                  <feather-icon
                                    icon="BarChart2Icon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="viewStaticTopic(itemTopic)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.viewStatistical') }}</span>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"  @click="viewNews(itemTopic)">
                                  <feather-icon
                                    icon="MessageSquareIcon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="viewNews(itemTopic)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.viewNews') }}</span>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="editTopic(itemTopic, item)">
                                  <feather-icon
                                    icon="Edit3Icon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="editTopic(itemTopic, item)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.editTopic') }}</span>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="copyLink(itemTopic,item)">
                                  <feather-icon
                                    icon="CopyIcon"
                                    style="vertical-align:middle;width:1rem"
                                    v-if="itemTopic.status == undefined"
                                    :data-url="itemTopic.topicName"
                                    @click="copyLink(itemTopic,item)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.copyTopic') }}</span>
                                </li>
                                <!--                                <li class="vx-card flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
                                <!--                                  <feather-icon-->
                                <!--                                    icon="StarIcon"-->
                                <!--                                    style="vertical-align:middle;width:1rem"-->
                                <!--                                  >-->
                                <!--                                  </feather-icon>-->
                                <!--                                  <span-->
                                <!--                                    class="font-action ml-2 mt-1">{{ $t('projectAndTopic.tickFavouriteTopic') }}</span>-->
                                <!--                                </li>-->
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="confirmDeleteRecord(itemTopic)">
                                  <feather-icon
                                    icon="Trash2Icon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="confirmDeleteRecord(itemTopic)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.deleteTopic') }}</span>
                                </li>
                              </ul>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>
                      <!--                    các từ khóa-->
                      <div class="vx-row ml-6" v-for="(key, indexKey) in itemTopic.keywords" :key="indexKey" >
                        <div class="ml-2 mr-2" v-if="item.color"
                             style="width: 15pt;height: 15pt;border-radius:5pt"
                             :style="{background : item.color}">
                        </div>
                        <div class="ml-2 mr-2" v-else
                             style="width: 15pt;height: 15pt;border-radius:5pt;background: rgb(var(--vs-primary),1)">
                        </div>
                        <span style="font-size: 11pt;color: rgb(110 107 123)"> {{ key.keyword }}</span>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </div>
            </VuePerfectScrollbar>
          </vs-collapse-item>
        </vs-collapse>
      </div>
      <!--      Collapse cá dự án khác-->
      <div class="other-projects mt-2">
        <vs-collapse :type="type">
          <vs-collapse-item icon-arrow="arrow_drop_down">
            <div slot="header" style="height: 20px;margin-top: -5px">
              <div class="vx-row" style="margin-left: 8px;">
                <div style="width: 20px;height: 20px;background-color:#0A7FFD;border-radius:5px "></div>
                <span class="ml-2 mt-1 font-bold"
                      style="font-size: 14px;color:  rgb(94 88 115)">{{ $t('projectAndTopic.otherTopics') }}</span>
                <span class=" mt-1 ml-6 mr-6"
                      style="font-size: 14px;color:  rgb(185 185 195)">{{
                    countOther
                  }} {{ $t('projectAndTopic.topicC') }}</span>
                <div class="buttonAdd" style="position: absolute;right: 40px">
                  <vs-button icon-pack="feather"
                             icon="icon-plus"
                             color="primary"
                             type="flat"
                             style="color: rgb( 47 128 237);font-size: 12px;margin-top: -4px; z-index:1"
                             @click="createNewTopic"
                  >TẠO CHỦ ĐỀ MỚI
                  </vs-button>
                </div>
                <!--                dropdow các chủ đề khác-->
                <div class="dropdown" style="position: absolute;right: 10px">
                  <vs-dropdown class="cursor-pointer" style="margin-top: 2px;">
                    <feather-icon
                      icon="MoreHorizontalIcon"
                      class=""
                      style="color: rgb(110 107 123);width: 1.7rem"
                    >
                    </feather-icon>
                    <vs-dropdown-menu>
                      <ul style="min-width: 228pt">
                        <li class="border-bottom flex py-2 px-4 cursor-pointer">
                          <div class=" py-2 px-4">
                            <div class="vx-row">
                              <span>{{
                                  $t('projectAndTopic.status')
                                }} : {{ $t('projectAndTopic.isActive') }}</span>
                            </div>
                          </div>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="viewStatistical">
                          <feather-icon
                            icon="BarChart2Icon"
                            style="vertical-align:middle;width:1rem"
                            @click="viewStatistical"
                          >
                          </feather-icon>
                          <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.viewStatistical') }}</span>
                        </li>
                      </ul>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </div>
            <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0"
                                 :settings="settings" style="min-height: 200px">
              <div class="topic"  style="margin-top: -10px;">
                <div class=" m-2 vx-row" style="color: rgb(185 185 195);width: 98%"
                     v-for="(item, index) in responseData.filter(item => item.isOther)"
                     :key="index">
                  <vs-collapse >
                    <vs-collapse-item not-arrow>
                      <div slot="header" class="vx-row ml-6" style="height: 10px;margin-top: -20px;">
                        <div class="vx-row">
                          <div class="button">
                            <vs-button v-if="item.buttonChecked" icon-pack="feather"
                                       icon="icon-chevron-down"
                                       color="primary"
                                       type="flat"
                                       @click="checkedChevron(item)"
                            >
                            </vs-button>
                            <vs-button v-else icon-pack="feather"
                                       icon="icon-chevron-up"
                                       color="primary"
                                       type="flat"
                                       @click="checkedChevron(item)"

                            >
                            </vs-button>
                          </div>
                          <vs-chip class="ag-grid-cell-chip m-2" color="primary">
                            <span class="" style="font-size: 12px">{{ item.topicName }}</span>
                          </vs-chip>
                          <div class="mt-2" v-if="item.statusData" @click="crawlData(item)">
                            <feather-icon v-if="item.color"
                                          icon="PauseIcon"
                                          class="float-left ml-4"
                                          style="width: 1.5rem"
                                          :style="{color : item.color}"
                            >
                            </feather-icon>
                            <feather-icon v-else
                                          icon="PauseIcon"
                                          class="float-left ml-4"
                                          style="width: 1.5rem;color: rgb(var(--vs-primary),1)"

                            >
                            </feather-icon>
                          </div>
                          <div class="mt-2" v-else @click="crawlData(item)">
                            <feather-icon v-if="item.color"
                                          icon="PlayCircleIcon"
                                          class="float-left ml-4"
                                          style="width: 1.5rem"
                                          :style="{color : item.color}"
                            >
                            </feather-icon>
                            <feather-icon v-else
                                          icon="PlayCircleIcon"
                                          class="float-left ml-4"
                                          style="width: 1.5rem;color: rgb(var(--vs-primary),1)"
                            >
                            </feather-icon>
                          </div>
                          <span class=" mt-2 ml-6 mr-6"
                                style="font-size: 13px;color:  rgb(185 185 195)"> {{item.keywords.length}} {{
                              $t('projectAndTopic.keyword')
                            }}</span>
                          <feather-icon
                            icon="PlusCircleIcon"
                            class="float-left ml-4 mr-6"
                            style="color: rgb(var(--vs-primary),1);width: 1.5rem"
                          >
                          </feather-icon>
                          <vs-dropdown class="cursor-pointer mt-2">
                            <feather-icon
                              icon="MoreVerticalIcon"
                              class=""
                              style="color: rgb(110 107 123);width: 1.7rem"
                            >
                            </feather-icon>
                            <vs-dropdown-menu>
                              <ul style="min-width: 228pt">
                                <li class="border-bottom flex py-2 px-4 cursor-pointer">
                                  <div class=" py-2 px-4">
                                    <div class="vx-row">
                                      <span
                                        style="font-size: 10pt">{{
                                          $t('projectAndTopic.status')
                                        }} : {{ $t('projectAndTopic.isActive') }}</span>
                                    </div>
                                  </div>
                                </li>
                                <li class="border-bottom py-2 px-4 cursor-pointer ">
                                  <div class="vx-col">
                                    <span
                                      style="color: rgb( 185 185 195)">{{
                                        $t('projectAndTopic.info')
                                      }}</span>
                                    <div class="info-topic"
                                    >
                                      <div v-if="item.createdBy != null">
                        <span v-if="item.currentUserName != item.createdBy">
                          {{ $t('projectAndTopic.createBy') }}: &nbsp;
                        </span>
                                        <span class="color-col"> {{
                                            item.createdBy
                                          }}</span>
                                      </div>
                                      <div v-else>
                                        <span class="color-col">{{ $t('projectAndTopic.creator') }} : {{
                                            item.createdBy || item.modifiedBy
                                          }}</span>
                                      </div>
                                      <div>
                                        <span>{{ $t('projectAndTopic.createDate') }} : {{
                                            item.createdDateString
                                          }}  </span>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="viewStaticTopic(item)">
                                  <feather-icon
                                    icon="BarChart2Icon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="viewStaticTopic(item)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.viewStatistical') }}</span>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="viewNews(item)">
                                  <feather-icon
                                    icon="MessageSquareIcon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="viewNews(item)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.viewNews') }}</span>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="editTopic(item,index)">
                                  <feather-icon
                                    icon="Edit3Icon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="editTopic(item,index)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.editTopic') }}</span>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="copyLink(item)">
                                  <feather-icon
                                    icon="CopyIcon"
                                    style="vertical-align:middle;width:1rem"
                                    v-if="item.status == undefined"
                                    :data-url="item.topicName"
                                    @click="copyLink(item)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.copyTopic') }}</span>
                                </li>
                                <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="confirmDeleteRecord(item)">
                                  <feather-icon
                                    icon="Trash2Icon"
                                    style="vertical-align:middle;width:1rem"
                                    @click="confirmDeleteRecord(item)"
                                  >
                                  </feather-icon>
                                  <span class="font-action ml-2 mt-1">{{ $t('projectAndTopic.deleteTopic') }}</span>
                                </li>
                              </ul>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>
                      <div class="vx-row ml-6" v-for="(key, indexKeyword) in item.keywords" :key="indexKeyword">
                        <div class="ml-2 mr-2"
                             style="width: 15pt;height: 15pt;background: rgba(var(--vs-primary),1);border-radius:5pt ">
                        </div>
                        <span style="font-size: 11pt;color: rgb(110 107 123)">{{ key.keyword }}</span>
                      </div>

                    </vs-collapse-item>
                  </vs-collapse>

                </div>
              </div>
            </VuePerfectScrollbar>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </div>
    <PopupConfirm :active="activeConfirm" :onSuccess="onSuccess" :close="closePopup"/>
  </div>

</template>
<script>
import moment from "moment";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {BBadge} from 'bootstrap-vue'
import PopupConfirm from "../../notify/PopupConfirm";

export default {
  components: {
    VuePerfectScrollbar,
    BBadge,
    PopupConfirm
  },
  data() {
    return {
      buttonChecked : true,
      removeTopic: false,
      removeGruop: false,
      activeConfirm: false,
      type: 'border ',
      length: null,
      startDateString: null,
      description: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .30,
        suppressScrollX: true
      },
      keywords: [{
        keyword: "",
        action: []
      }],
      optionGroupTopics: [],
      optionPriority: [],
      topicName: null,
      topics: [],
      statusData: true,
      active: true,
      refresh: null,
      topicId: null,
      topicGroupId: null,
      responseData: [],
      countBranding: null,
      optionalBranding: [],
      countProductBranding: null,
      optionalProductBranding: [],
      countPersonalBranding: null,
      optionalPersonalBrandig: [],
      countOther: null,
      lengthTopic: null,
      articleSource: [],
      excludeKeyword: null,
      topicGroupdId: null,
      updateActive: false,
      colorTopic: null,
      email : null,
      favourite: true,
    }
  },
  computed: {
    state() {
      return Boolean(this.valueCheckedRadio);
    },
    selectedTopicGroup: {
      get() {
        let object = this.optionGroupTopics.find(el => el.value === this.topicGroupdId);
        if (!object) return null;
        return {
          label: object.label,
          value: object.value
        }
      },
      set(object) {
        this.topicGroupdId = object.value
      }
    },
    validateForm() {
      return !this.errors.any();
    },
    mergeAction: {
      get: function () {
        let object = this.optionalMergeAction.find(el => el.value === this.valueMergeAction);
        if (!object) return null;
        return {
          label: object.label,
          value: object.value
        }
      },
      set: function (object) {
        this.valueMergeAction = object ? object.value : null
      }
    }
  },

  methods: {
    crawlData: function (event) {
      this.$vs.loading();
      const payload = {
        ...event,
        statusData: !event.statusData,
      }
      this.$business.post(`/topic/update/`, payload).then(() => {
        this.$vs.loading.close();
        this.initScreen();
        return this.showUpdateCrawl(event);
      })

    },
    tickFavouriteGroupTopic: function (event) {
      this.$vs.loading();
      const payload = {
        color: event.color,
        description: event.description,
        groupName: event.label,
        id: event.value,
        favourite: !event.favourite,
      };
      this.$business.post(`/topic-group/update`, payload).then(() => {
        this.$eventBus.$emit('update-priority', true)
        this.$vs.loading.close();
        this.initScreen();
        return this.showUpdateSuccess(event);
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
    showUpdateSuccess(event) {
      const isFavourite = event.favourite;
      this.$store.commit('UPDATE_USER_SUCCESS', true);
      this.$vs.notify({
        color: 'primary',
        text: ` ${isFavourite ? this.$t('projectAndTopic.cancelText') : this.$t('projectAndTopic.update')} ` + ` ${this.$t('projectAndTopic.textFavourite')}`,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      })
    },
    showUpdateCrawl(event) {
      const isStatusData = !event.statusData;
      this.$store.commit('UPDATE_USER_SUCCESS', true);
      this.$vs.notify({
        color: 'primary',
        text: ` ${isStatusData ? this.$t('projectAndTopic.continue') : this.$t('projectAndTopic.pause')} ` + ` ${this.$t('projectAndTopic.crawl')}` + ` "${event.topicName}" `,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      })
    },
    createTopic: function (event) {
      let id = event.value;
      this.$router.push(`/user/v2/create-new-topic?id=${id}`).catch(() => {
      })
      this.$business.get(`topic/find-by-id/` + id).then((res) => {
        const data = res.data;
        this.topicGroupName = data.groupName;
        this.topicGroupdId = data.id;
        this.userId = data.userId;
        this.isUpdateGroup = true;
        this.updateActive = true;
      })
    },
    updateProject: function (event) {
      let id = event.value;
      let color = event.color;
      this.$router.push(`/user/v2/update-project?id=${id}&color=${color}`).catch(() => {
      })
      this.$business.get(`topic-group/find-by-id/` + id).then((res) => {
        const data = res.data;
        this.topicGroupName = data.groupName;
        this.topicGroupdId = data.id;
        this.userId = data.userId;
        this.isUpdateGroup = true;
        this.updateActive = true;
      })
    },
    openPopupShareTopicByGroupId: function (item) {
      this.activePopupShareTopic = true;
      this.emailShare = null;
      this.topicGroupdId = item.value;
      this.shareByTopicId = true;
      this.payloadPopupShare = false;
    },
    shareTopic: function (event) {
      this.valueMergeAction = null;
      this.registerData = event;
      this.shareTopicInTable = true;
      this.activePopupShareTopic = true;
      this.emailShare = null;
    },
    openPopupShare() {
      this.activePopupShareTopic = true;
      this.payloadPopupShare = true;
      this.emailShare = null;
      this.shareByTopicId = false;
      document.getElementsByClassName('text-danger text-sm')[0].style.display = "none"
    },
    viewStatistical : function (event) {
      let id = null;
      let groupId = event.value;
      this.$router.push(`/user/dashboard-v2?id=${id}&groupId=${groupId}`).catch(() => {
      })
    },
    viewStaticTopic: function(event){
      let id = event.id;
      let groupId = event.topicGroupId;
      this.$router.push(`/user/dashboard-v2?id=${id}&groupId=${groupId}`).catch(() => {
      })
    },
    viewNews : function (event) {
      let id = event.id
      this.$router.push(`/user/article-details-v2?id=${id}`).catch(() => {
      })
    },
    activePopupTopicGroup: function (event) {
      if (event) {
        this.topicGroupdId = event.value
      }
      this.$business.get(`topic-group/find-by-id/` + this.topicGroupdId).then((res) => {
        const data = res.data;
        this.topicGroupName = data.groupName;
        this.topicGroupdId = data.id;
        this.userId = data.userId;
        this.isUpdateGroup = true;
        this.updateActive = true;
      })
    },
    closePopup() {
      this.activeConfirm = false;
    },
    onSuccess() {
      if (this.removeGruop) {
        this.removeTopicGroup();
      }
      if (this.removeTopic) {
        this.deleteRecord();
      }
    },
    removeTopicGroup: function () {
      this.$vs.loading();
      this.$business.post(`topic-group/delete/${this.topicGroupdId}`).then(() => {
        this.initScreen();
        this.$vs.loading.close();
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textSuccessDelete'),
          icon: 'icon-alert',
          iconPack: 'feather',
          color: 'primary'
        })
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
      this.activeConfirm = false;
      this.removeGruop = false;
    },
    confirmRemoveTopicGroup: function (event) {
      if (event) {
        this.topicGroupdId = event.value;
      }
      this.activeConfirm = true;
      this.removeGruop = true;
    },
    confirmDeleteRecord(itemTopic) {
      this.topicId = itemTopic.id;
      this.activeConfirm = true;
      this.removeTopic = true;
    },
    deleteRecord() {
      this.$vs.loading();
      this.$business.post(`/topic/delete/${this.topicId}`).then(() => {
        this.initScreen();
        this.$vs.loading.close();
        return this.$vs.notify({
          text:this.$t('projectAndTopic.textSuccessDelete2') ,
          icon: 'icon-alert',
          iconPack: 'feather',
          color: 'primary'
        })
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
      this.activeConfirm = false;
      this.removeTopic = false;
    },
    getTopicGroups: function () {
      let userInfo = JSON.parse(localStorage.userInfo);
      this.email = userInfo.email;
      return new Promise((resolve, reject) => {
        this.$business.post('/topic-group/find-by-conditions', {}).then((res) => {
          this.optionGroupTopics = res.data;
          this.length = this.optionGroupTopics.length;
          if (this.optionGroupTopics.length > 0) {
            this.optionGroupTopics = this.optionGroupTopics.map(el => {
              if (el.groupName && el.groupName.length > 16) {
                el.groupName = el.groupName.slice(0, 16) + '...';
              }
              el.startDate = moment(el.createdDate || el.modifiedDate).format("DD/MM/YYYY");
              return {
                label: el.groupName,
                value: el.id,
                color: el.color,
                startDateString  : el.startDate,
                description: el.description,
                endDate: el.endDate,
                favourite: el.favourite,
                userId: el.userId,
                currentUserId: userInfo.id,
                currentUser: userInfo.email,
                createdUser: el.createdBy,
              }

            });
          }
          resolve();
        }).catch(() => reject())
      })
    },
    getPriority: function () {
      this.$business.post('/topic-group/find-by-conditions', {}).then((res) => {
        this.optionPriority = res.data.filter(el => el.favourite)
        if (this.optionPriority.length > 0) {
          this.optionPriority = this.optionPriority.map(el => {
            if (el.groupName && el.groupName.length > 20) {
              el.groupName = el.groupName.slice(0, 20) + '...';
            }
            return {
              label: el.groupName,
              value: el.id,
              color : el.color,
            }
          });
        }
      }).catch()
    },
    getTopicByOrganizationBranding: function () {
      const result = this.optionGroupTopics;
      this.$vs.loading();
      const payload = {};
      this.$business
        .post(`topic/find-by-conditions`, payload)
        .then(res => {
          this.$business.post(`share-topic/get-all-share`, {}).then((response) => {
            let currentUserName = JSON.parse(localStorage.userInfo).email
            const dataShare = response.data;
            const dataShareTopic = response.data;
            if (dataShare.status == 0) {
              dataShareTopic.forEach(key => {
                key.status = dataShare.status;
              })
            }
            const data = [...res.data, ...dataShareTopic.filter(item => item.status == 0 || item.status == 1)];
            this.statusShare = response.data.status;
            if (res.status == "200") {
              this.countBranding = this.optionalBranding.length;
              this.countProductBranding = this.optionalProductBranding.length;
              this.countPersonalBranding = this.optionalPersonalBrandig.length;
              this.$vs.loading.close();
              this.responseData = data;
              data.forEach(el => {
                el.currentUserName = currentUserName;
                if (el.topicName && el.topicName.length > 16) {
                  el.topicName = el.topicName.slice(0, 16) + '...';
                }
                el.createdDateString = moment(el.createdDate || el.modifiedDate).format("DD/MM/YYYY");
                el.buttonChecked = true
                if (!this.optionGroupTopics.find(item => item.value == el.topicGroupId)) {
                  el.isOther = true
                } else {
                  el.isOther = false
                }
              });
              this.topics = data;
              const countOther = data.filter(item => item.isOther);
              this.countOther = countOther.length;
            }
            let resultFilter = [];
            let checkedShareId = [];
            result.forEach(el => {
              resultFilter = data.filter(topic => el.value == topic.topicGroupId)
              checkedShareId = resultFilter.filter(filter => !filter.shareId);
              // let resultFilterOther = data.filter(topic => el.value != topic.topicGroupId)
              // let checkedShareOther = resultFilterOther.filter(filter => !filter.shareId);
              if (checkedShareId.length > 0) {
                el.checkedAll = true;
              }
              if (el.isOther) {
                this.checkedSelected = true;
              }
            })
          })
            .catch(() => {
              return this.$vs.loading.close();
            });
        })
    },
    copyLink: function (event) {
      this.$vs.loading();
      this.copyData(event);
    },
    copyData: function (event) {
      const payload = {
        topicGroupId: event.topicGroupId,
        userId: event.userId,
        favourite: event.favourite,
        keywords: event.keywords,
        articleSource: event.articleSource,
        excludeKeyword: event.excludeKeyword,
        topicName: event.topicName + '(copy)'
      }
      this.$business.post('/topic/create', payload).then(() => {
        this.$vs.loading.close();
        this.initScreen();
        return this.$vs.notify({
          text: `${this.$t('projectAndTopic.textSuccessCopy')}` + ` ${event.topicName} `,
          iconPack: 'feather',
          icon: 'icon-alert',
          color: 'primary'
        })
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
    saveCopyData: function () {
      this.responseData.filter(el => el.checked == true).forEach(data => {
        this.copyData(data);
      });
    },

    getTopic() {
      let conditions = {};
      this.$business
        .post("/topic/find-by-conditions", conditions)
        .then(topics => {
          this.$business.post(`share-topic/get-all-share`, {}).then((res) => {
            this.topics = topics.data;
            this.topics.forEach(item => {
              if (item.favourite) {
                this.searchByTopic(item);
              }
            });
            this.initScreen();
            this.topics.unshift({topicName: "Tất cả", id: null});
            const statusShare = res.data.topic;
            statusShare.forEach(value => {
              this.topics.push(value);
            })
          }).catch(() => {

          })

        })
        .catch(() => {
        });
    },
    createNewTopic: function () {
      this.$router.push('/user/v2/create-new-topic').catch(() => {
      })
    },
    createNewProject: function () {
      this.$router.push('/user/v2/create-new-project').catch(() => {
      })
    },
    createNewKeyword: function (event) {
      let id = event.id;
      this.$router.push(`/v2/pages/project/create-new-keyword?id=${id}&isUpdate=${true}`).catch(() => {
      })
    },
    checkedChevron: function (event) {
      event.buttonChecked = !event.buttonChecked
    },
    editTopic: function (event, topicGroup) {
      this.$router.push(`/user/v2/update-topic?id=${event.id}&isUpdate=${true}`).catch(() => {
      })
    },
    updatePriority: function (event) {
      this.getTopicGroups.push(event)
    },
    initScreen() {
      this.getTopicGroups().then(() => {
        this.getTopicByOrganizationBranding();
      });
      this.getPriority();
    }
  },
  async saveChanges(evt) {
    evt.preventDefault();
    const keyword = this.keywords.map(key => {
      return key.keyword;
    })
    for (let i = 0; i < keyword.length; i++) {
      if (!keyword[i]) {
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textKeyword'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
    }
    if (this.keywords) {
      this.keywords = this.keywords.map(keyword => {
        let action = [];
        if (keyword.action) {
          action = keyword.action.map(action => {
            return action.text;
          }).filter(item => item);
        }
        return {
          keyword: keyword.keyword,
          action: action
        }
      });
    }
    this.valueCheckbox = [];
    this.valueCheckbox.push(101, 102, 103, 104, 105, 106, 108, 109, 110, 111, 113);

    let checked = false;
    if (checked) {
      return this.$vs.notify({
        text: this.$t('projectAndTopic.textKeyword2'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    }
    if (this.valueCheckbox.length == 0) {
      return this.$vs.notify({
        text: this.$t('managerKeyword.textSource'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    }
    if (this.selectedCompetitor) {
      this.valueSelected = 0;
    }
    if (this.selectedPersonal) {
      this.valueSelected = 1;
    }
    if (this.selectedOther) {
      this.valueSelected = 2;
    }
    if (!this.topic.topicName) {
      return this.$vs.notify({
        text: this.$t('projectAndTopic.textTheme2'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    }
    if (this.isUpdate) {
      this.topic.id = this.topicId;
    } else {
      this.topic.id = null;
    }
    this.topic.articleSource = this.valueCheckbox;
    this.topic.excludeKeyword = this.tagsListAction[0].action.map(item => item.text);
    this.topic.keywords = this.keywords;
    this.topic.topicGroupId = this.topicGroupdId;
    this.topic.topicRelationship = this.radio;
    this.topic.favourite = false;
    let path = this.isUpdate ? ('/topic/update') : '/topic/create';
    this.$vs.loading();
    this.$business.post(path, this.topic).then(() => {

      this.$vs.loading.close();
      this.$vs.notify({
        color: 'primary',
        text: ` ${this.isUpdate ? this.$t('projectAndTopic.update') : this.$t('projectAndTopic.add')} ` + ` ${this.$t('projectAndTopic.textAdd')}`,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      });
      this.activePopupTopic = false;
      // this.topic ={
      //   topicName: null,
      //   topicGroupId: null,
      //   excludeKeyword:null,
      //   articleSource:[]
      // }
      this.initScreen();
    }).catch((err) => {
      this.$vs.loading.close();
      return this.$vs.notify({
        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    });
  },
  async created() {
    this.$eventBus.$on('unfavourite', (event) => {
      if (event) {
        this.initScreen();
      }
    });
    this.initScreen();
    this.getTopicByOrganizationBranding();
  }
}
</script>

<style scoped>
.count-other {
  margin-top: 2px;
  width: 20px;
  height: 20px;
  background-color: #0A7FFD;
  border-radius: 5px;
  font-size: 12px;
}

.font-action {
  font-size: 10pt;
  line-height: 12pt;
}

.vs-collapse-item--content {
  max-height: 425.8pt;
}

.open-item {
  max-height: 425pt;
}

.color-group {
  margin-top: 2px;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  font-size: 12px;

}

.back {
  background-color: #2F80ED !important;
  color: white !important;
}

.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style lang="css">
.notify-toast{
  background-color: #277df6;
  color: white;
  border-radius: 30px;
  height: 3rem !important;
  font-size: 16px !important;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
}
.down-arrow .vs-collapse-item--icon-header {
  left: 0 !important;
  margin-left: 10px;
}
</style>
